export default "__VITE_ASSET__ZORznNXY__"